import { EnvConfig } from '../../config/EnvConfig'
import { GamesLanguages } from '../constants'
import { getWebsiteUrl } from '../getWebsiteUrl'
import { convertOptionsToQueryParams, generateURL } from './generateURL'
import { getMockURL } from './mockURL'

const locale = process.env.GATSBY_INTL_LOCALE
const language = GamesLanguages?.ISO6391?.[locale]

export const setSmartsoftURL = ({
  providerData,
  isMobile,
  desktopSlug,
  mobileSlug,
  casinoSlug,
  slug,
  skin,
  casinoProvider,
  isMock,
}) => {
  const websiteURL = getWebsiteUrl()

  const options = [
    {
      param: 'GameCategory',
      value: isMobile ? mobileSlug : desktopSlug,
    },
    {
      param: 'GameName',
      value: slug,
    },
    {
      param: 'Token',
      value: providerData?.token ? providerData?.token : 'DEMO',
    },
    {
      param: 'PortalName',
      value: providerData?.token
        ? EnvConfig.GATSBY_KTO_SMART_SOFT_PORTAL_NAME
        : 'DEMO',
    },
    {
      param: 'Lang',
      value: language,
    },
    {
      param: 'chat',
      value: 'no',
    },
    {
      param: 'ReturnUrl',
      value: `${websiteURL}${casinoSlug}`,
    },
  ]

  if (skin) {
    options?.push({
      param: 'Skin',
      value: skin,
    })
  }

  const baseURL = EnvConfig.SMART_SOFT_URL
  return isMock
    ? getMockURL({
        path: 'init',
        params: convertOptionsToQueryParams(options),
        casinoProvider,
      })
    : generateURL({ baseURL, options })
}
